import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { BlinkingEyes } from "@/components/BlinkingEyes";
import { useLang } from "@/i18n";

const NotFound = () => {
  const { lang, t } = useLang();

  // Static hosting cannot set the status code from the client, so the crawler
  // signal is the noindex below plus the 404.html emitted by the prerender.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#F5F1E8] min-h-screen flex flex-col overflow-x-hidden">
      <Seo
        title={t.seo.notFound.title}
        description={t.seo.notFound.description}
        path="/404"
        lang={lang}
        noindex
      />
      <Navbar />
      <main
        data-testid="page-404"
        className="flex-1 flex flex-col items-center justify-center text-center px-6 py-28"
      >
        <BlinkingEyes variant="chocolate" width={54} testId="notfound-eyes" />
        <p className="mt-8 text-[#3B2523]/70 uppercase tracking-[0.3em] text-xs font-semibold">
          Error 404
        </p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#3B2523] mt-4">
          {t.notFound.title}
        </h1>
        <p className="text-[#3B2523]/70 text-base md:text-lg mt-5 max-w-[520px] leading-relaxed">
          {t.notFound.text}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-10 w-full sm:w-auto">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="inline-flex items-center justify-center min-h-[48px] bg-[#3B2523] text-[#F5F1E8] font-semibold px-8 py-4 rounded-full transition-transform duration-300 hover:-translate-y-0.5"
          >
            {t.notFound.cta}
          </Link>
          <Link
            to="/#coffees"
            data-testid="notfound-coffees-link"
            className="inline-flex items-center justify-center min-h-[48px] border border-[#3B2523]/30 text-[#3B2523] font-semibold px-8 py-4 rounded-full transition-colors duration-300 hover:bg-[#3B2523] hover:text-[#F5F1E8]"
          >
            {t.notFound.cta2}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
